import { Outlet } from 'react-router-dom';

import { Routes } from '@app/constants/routes';
import { mutable } from '@app/utils/type.utils';
import { useMatchActiveRoute, useTypedNavigate } from '@app/router';
import { Page } from '@app/hoc';
import { Typography } from '@app/components';

import { Tabs, Tab } from '@mui/material';

// admin-emailbeheer, restructured 2026-08-23 per Danny's explicit request: one sidebar entry
// ("Email reports"), four tabs inside - matches admin-email-mockup_3.html's own single-page/tab
// structure instead of the four separate sidebar entries blok B originally shipped with. Same
// route-per-tab + <Outlet/> pattern as UserManagementModule, so each tab keeps its own
// bookmarkable URL and its own independent filter query params.
const tabRoutes = mutable([
  Routes.admin.email.report,
  Routes.admin.email.customer.index,
  Routes.admin.email.log,
  Routes.admin.email.deliverability,
] as const);

export const AdminEmailModule: React.FC = () => {
  const navigate = useTypedNavigate();
  const value = useMatchActiveRoute(tabRoutes);
  const handleChange = (_: React.ChangeEvent<unknown>, to: typeof tabRoutes[number]) => {
    navigate({ to });
  };

  return (
    <Page>
      <div className="p-5 pb-0">
        <Typography variant="h4">Email reports</Typography>
        <Typography variant="xs" className="text-gray-400">
          Send status, delivery and history per customer - source: SendGrid Event Webhook
        </Typography>
      </div>
      <div className="px-5">
        <Tabs value={value} onChange={handleChange}>
          <Tab label="Email report" value={tabRoutes[0]} />
          <Tab label="Per customer" value={tabRoutes[1]} />
          <Tab label="Send log" value={tabRoutes[2]} />
          <Tab label="Deliverability" value={tabRoutes[3]} />
        </Tabs>
      </div>
      <div className="p-5">
        <Outlet />
      </div>
    </Page>
  );
};
